import { render } from "./ThinkTankComment.vue?vue&type=template&id=61509cda"
import script from "./ThinkTankComment.vue?vue&type=script&lang=js"
export * from "./ThinkTankComment.vue?vue&type=script&lang=js"
script.render = render

export default script